// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"40ad6aea","577":"ddef90fd","896":"706bc698"}[chunkId] + ".chunk.js";
};